// extracted by mini-css-extract-plugin
export default {"container":"Bha-z","heading":"Cha-z","links":"Dha-z","linkBtn":"Eha-z","disabled":"Fha-z","linkUppercaseBold":"Gha-z","copy":"Hha-z","subCopy":"Iha-z"};